import { downloadFile } from 'src/download_file';
import { Attachment } from '@crossiety/design';

Attachment.downloadFile = downloadFile;

export default Attachment;
